import React from 'react';
import styles from './InputError.module.css';

type InputErrorProps = {
    error: string;
};

const InputError: React.FC<InputErrorProps> = ({ error }) => {
    return <div className={styles.error}>{error}</div>;
};

export default InputError;
